export default __webpack_public_path__ + "static/media/synchronization.166f2019.svg";